import { render, staticRenderFns } from "./ModalChooseNameAndDescription.vue?vue&type=template&id=12619e4a"
import script from "./ModalChooseNameAndDescription.vue?vue&type=script&lang=js"
export * from "./ModalChooseNameAndDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12619e4a')) {
      api.createRecord('12619e4a', component.options)
    } else {
      api.reload('12619e4a', component.options)
    }
    module.hot.accept("./ModalChooseNameAndDescription.vue?vue&type=template&id=12619e4a", function () {
      api.rerender('12619e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalChooseNameAndDescription.vue"
export default component.exports